module.exports = __webpack_public_path__ + "img/icon-session.0448e782.svg";